module.exports = __webpack_public_path__ + "static/media/Compare_black.e308ad6d.svg";